<div class="border-0 px-4 py-1 scroll-container" ref="manageTrustType">
  <NavigationBackButton/>
  <div class="card-header card-header-primary rounded-lg mt-2 shadow py-1 px-3">
    <div class="nav-tabs-navigation">
      <div class="nav-tabs-wrapper p-0 ">

        <ul class="nav p-0 border-0" data-tabs="tabs">
          <li class="nav-item me-2" v-for="(tab, index) in tabs" :key="index"
            :class="[ active_tab === tab ? 'active' : 'inactive' ]" @click="set_active_tab(tab)">
            <a class="nav-link text-white text-decoration-none fs-5 fw-bold py-1 mt-2" href="#profile" data-toggle="tab">
              <i class="bi bi-diagram-3 fs-4 me-2"></i>
              Entity Types
            </a>
          </li>
        </ul>

        <div class="text-end mb-2">
          <button class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark py-1" data-bs-toggle="modal" data-bs-target="#create_trust_type">
            Create Entity Type
          </button>
        </div>

      </div>
    </div>
  </div>
  <div class="rounded-lg border-0 mt-2 ">
      <div v-if="active_tab === 'Entity Types'">
        <div class="glassy-table border-0 rounded-lg mt-2">
              <!-- Table for Trust Types -->
              <GlobalTable
                v-if="trust_types_headers.length"
                :headers="trust_types_headers"
                :data="table_safe_trust_types"
                table_id="entity_management_table">
                <template #actions="{ row }">
                  <button
                    class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
                    @click="redirect_to_view_entity(row.id)">
                    Manage
                  </button>
                  <button
                    class="btn btn-primary-dark btn-sm rounded-small edit-btn text-xxs shadow text-dark"
                    data-bs-toggle="modal"
                    data-bs-target="#edit_trust_type"
                    @click="prepopulate_edit_modal(row)">
                    Edit
                  </button>
                  <button
                    class="btn btn-primary-dark btn-sm rounded-small edit-btn text-xxs shadow text-dark"
                    data-bs-toggle="modal"
                    data-bs-target="#assign_sub_entity_modal"
                    @click="open_assign_modal(row)">
                    Assign Parties to Entity Type
                  </button>
                </template>
              </GlobalTable>
          </div>
      </div>
  </div>
</div>


<teleport to="body">
<div class="modal fade" id="assign_sub_entity_modal" tabindex="-1" aria-labelledby="assign_sub_entity_modal_label" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content shadow-lg border-0 rounded-3">

        <!-- Modal Header -->
        <div class="modal-header cute-header d-flex align-items-center justify-content-between px-4 py-3 border-0 rounded-top-3">
          <h5 class="modal-title text-white text-xxs fw-bold mb-0" id="assign_sub_entity_modal_label">Assign Parties to an Entity Type</h5>
          <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <!-- Modal Body -->
        <div class="modal-body p-4 bg-light">
          <!-- Section Title -->
          <div class="d-flex align-items-center justify-content-between mb-3">
            <div>
              <label class="form-label text-xxs fw-semibold me-2 mb-0">
                Assign Parties to:
              </label>
              <span class="fw-bold text-dark text-xxs">
                {{ current_form.parent_name }}
              </span>
            </div>
            <span class="badge bg-secondary rounded-pill text-xxs">
              {{ available_children.length }} Available
            </span>
          </div>


          <!-- DataTable -->
          <div  class="table-responsive">
            <table class="table table-bordered table-hover align-middle" id="assign_sub_entity_table" :key="'assign-table-' + datatable_key">
              <thead class="custom-header">
                <tr class="text-x">
                  <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">No</th>
                  <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Name</th>
                  <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Status</th>
                  <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Assign</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(child_item, index) in available_children" :key="child_item.id" class="text-xxs">
                  <!-- Counter -->
                  <td class="text-xxs text-start">{{ index + 1 }}</td>
                  <!-- Sub-Entity Name -->
                  <td class="text-xxs text-start">{{ child_item.entity_type_name }}</td>

                  <!-- Status -->
                  <td>
                    <span class="badge"
                          :class="{ 'bg-success': child_item.is_assigned, 'bg-secondary': !child_item.is_assigned }">
                      {{ child_item.is_assigned ? 'Assigned' : 'Unassigned' }}
                    </span>
                  </td>

                  <td class="text-center">
                    <div class="form-check form-switch d-flex justify-content-center">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        role="switch"
                        :id="'toggle-' + child_item.id"
                        :checked="child_item.is_assigned"
                        :disabled="child_item.is_loading"
                        @change="on_toggle_assign(child_item, $event)"
                      >
                    </div>
                  </td>
                </tr>
              </tbody>

            </table>
          </div>
        </div>

    </div>
  </div>
</div>
</teleport>

<!-- Create Trust Type Modal -->
 <teleport to="body">
<div class="modal fade" id="create_trust_type" tabindex="-1" aria-labelledby="create_trust_type_label" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
      <div class="modal-header border-bottom-0 cute-header shadow-lg">
        <p class="modal-title text-white text-xxs" id="create_project_label">Create Entity Type</p>
        <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="modal-form-group form-group mb-3">
          <label for="trust_type_name" class="modal-form-label form-label text-xxs">Entity Type Name:</label>
          <input type="text" v-model="trust_type_name" class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm" placeholder="Enter Entity Type Name Here">
          <small class="text-danger p-2 text-xxs fw-bold d-none project-name-messages">Please enter a entity type name</small>
          <small class="text-danger p-2 text-xxs fw-bold d-none error-messages"></small>
        </div>
        <div class="modal-form-group form-group mb-3">
          <label for="trust_type_description" class="modal-form-label form-label text-xxs">Entity Type Description:</label>
          <textarea type="text" v-model="trust_type_description"
            class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm"
            placeholder="Enter Entity Type Description Here"
            rows="4" cols="10">
          </textarea>
          <small class="text-danger p-2 text-xxs fw-bold d-none project-name-messages">Please enter a entity type description</small>
          <small class="text-danger p-2 text-xxs fw-bold d-none error-messages"></small>
        </div>

      </div>
      <div class="modal-footer border-0 p-2 d-flex justify-content-end">
        <button type="button" class="btn btn-primary-dark btn-sm px-3 shadow text-xxs" @click="create_trust_type">Save</button>
      </div>
    </div>
  </div>
</div>
</teleport>

<!-- Edit Trust Type Modal -->
 <teleport to="body">
<div class="modal fade" id="edit_trust_type" tabindex="-1" aria-labelledby="edit_trust_type_label" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
      <div class="modal-header border-bottom-0 cute-header shadow-lg">
        <p class="modal-title text-white text-xxs" id="edit_entity_type_label">Edit Entity Type</p>
        <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="modal-form-group form-group mb-3">
          <label for="trust_type_name" class="modal-form-label form-label text-xxs">Entity Type Name:</label>
          <input type="text" v-model="edit_trust_type_name" class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm">
          <small class="text-danger p-2 text-xxs fw-bold d-none edit-entity-type-messages">Please enter a entity type name</small>
          <small class="text-danger p-2 text-xxs fw-bold d-none error-messages"></small>
        </div>
        <div class="modal-form-group form-group mb-3">
          <label for="trust_type_name" class="modal-form-label form-label text-xxs">Entity Type Description:</label>
          <textarea type="text" v-model="edit_trust_type_description"
            class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm"
            rows="4" cols="10">
          </textarea>
          <small class="text-danger p-2 text-xxs fw-bold d-none edit-entity-type-description-messages">Please enter a entity type description</small>
          <small class="text-danger p-2 text-xxs fw-bold d-none error-messages"></small>
        </div>
      </div>
      <div class="modal-footer border-0 p-2 d-flex justify-content-end">
        <button type="button" class="btn btn-primary-dark btn-sm px-3 shadow text-xxs" @click="edit_trust_type">Save</button>
      </div>
    </div>
  </div>
</div>
</teleport>